import { render, staticRenderFns } from "./Chapuzon2025View.vue?vue&type=template&id=8f1254ea&"
import script from "./Chapuzon2025View.vue?vue&type=script&lang=ts&"
export * from "./Chapuzon2025View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports